import {IDocumentService, IPromise, ITimeoutService} from "angular";
import moment from "moment";
import {regNavn} from "./tredjepartsTjenestenavn";
import _ from "lodash";
import {Debugger} from "debug";
import {InterWindowBus} from "./InterWindowBus";

const debug:Debugger = require('debug')('BrukerInaktivitetTjeneste');

export class BrukerInaktivitetTjeneste {

    static regNavn = 'BrukerInaktivitetTjeneste';

    static forInjisering() {
        return [
            regNavn.ng.$document,
            regNavn.ng.$timeout,
            InterWindowBus.regNavn,
            BrukerInaktivitetTjeneste
        ]
    }

    constructor(private $document: IDocumentService, private $timeout: ITimeoutService, private interWindowBus:InterWindowBus) {
    }

    private monitorer: Inaktivitetsmonitor[] = [];
    private idTeller = 0;

    /**
     * Oppretter ny inaktivitetsmonitor.
     * Kaller er ansvarlig for å starte monitor ved å kalle {@link Inaktivitetsmonitor#start()} på returnert monitor.
     *
     * @param terskel for inaktivitet
     * @param vedInaktivitet metode som kalles etter [terskel] uten aktivitet
     */
    opprett(terskel: moment.Duration, vedInaktivitet: () => void): Inaktivitetsmonitor {
        const inaktivitetsmonitor = new Inaktivitetsmonitor(
            `${this.idTeller++}_BrukerInaktivitetTjeneste`,
            terskel.asMilliseconds(),
            vedInaktivitet,
            this.$document,
            this.$timeout,
            this.interWindowBus);
        this.monitorer.push(inaktivitetsmonitor);
        return inaktivitetsmonitor;
    }

    /** Stopper alle inaktivitetsmonitor. */
    stoppAlle() {
        _(this.monitorer).each(monitor => {
            monitor.stopp()
        });
    }

}

/**
 * Monitor som kaller angitt callback når bruker har vært innaktiv i angitt interval.
 * Merk at vi håndtere multiple-arkfaner/vinduer problematikk ved å benytte {@link InterWindowBus}
 * for å signalisere aktivitet til Inaktivitetsmonitor-instanser i andre nettleservinduer.
 */
export class Inaktivitetsmonitor {
    constructor(private id: string,
                private terskel: number,
                private vedInaktivitet: () => void,
                private $document: IDocumentService,
                private $timeout: ITimeoutService,
                private interWindowBus: InterWindowBus) {
        this.events = _(['keydown', 'keyup', 'click', 'mousemove', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'scroll', 'focus'])
          .map(event => `${event}.${id}`)
          .value();

        const signaliserReset = () => this.interWindowBus.signaliser(Inaktivitetsmonitor.innaktivitetsmonitorResetIWBHendelse);
        this.throtledSignaliserReset = <any>_.throttle(signaliserReset, 10000); //signaliserer over busen maks hvert 10. sekund
    }

    private static innaktivitetsmonitorResetIWBHendelse = 'Inaktivitetsmonitor_reset';

    private events:string[];
    private aktiv = false;
    private timeout: IPromise<any> = null;
    private sisteStart: Date;

    private throtledSignaliserReset:() => void;
    private vedAvreg: Function[] = [];

    /** Starter inaktivitetsmonitor. */
    start(): Inaktivitetsmonitor {
        this.aktiv = true;

        const _resetTimerOgBroadcast = () => this.resetTimerOgBroadcast();
        this.vedAvreg = this.events.map(event => this.registrerEventLytter(event, _resetTimerOgBroadcast));
        const _resetTimer = () => this.resetTimer();
        this.vedAvreg.push(this.interWindowBus.ved(Inaktivitetsmonitor.innaktivitetsmonitorResetIWBHendelse, <any>_.throttle(_resetTimer, 10000))); //signaliserer over busen maks hvert 10. sekund

        this.startTimer();
        return this;
    }

    /**
     * Om man har eksterne events, f.eks. ckeditor 'change' events og trenger å opppdatere timeren her
     */
    eksternEvent() {
        debug('eksternEvent');
        this.resetTimerOgBroadcast();
    }

    /** tid siden siste aktivitet */
    inaktivitetVarighet(): moment.Duration {
        return moment.duration(moment().diff(this.sisteStart));
    }

    /** Stopper inaktivitetsmonitor. */
    stopp(): Inaktivitetsmonitor {
        this.aktiv = false
        this.vedAvreg.forEach(f => f());
        this.avbrytTimer();
        return this;
    }

    // hjelpemtoder

    private registrerEventLytter(event:string, lytter){
        this.$document.on(event, lytter);
        return () => this.$document.off(event, lytter);
    }

    private resetTimerOgBroadcast() {
        this.resetTimer();
        this.throtledSignaliserReset();
    }

    private resetTimer() {
        this.avbrytTimer();
        this.startTimer();
        //debug("#### resetTimer ")
    }

    private startTimer() {
        this.timeout = this.$timeout(() => this.inaktivitetOverskredet(), this.terskel, false);
        this.sisteStart = new Date();
    }

    private avbrytTimer() {
        this.$timeout.cancel(this.timeout);
    }

    private inaktivitetOverskredet() {
        if (this.vedInaktivitet) this.vedInaktivitet();
    }
}
